import {
  useBlockProps,
  InspectorControls,
  MediaUpload,
  MediaUploadCheck
} from '@wordpress/block-editor'
import {
  PanelBody,
  TextControl,
  Button,
  ToggleControl,
  RangeControl
} from '@wordpress/components'
import { __ } from '@wordpress/i18n'

export default function Edit ({ attributes, setAttributes }) {
  const {
    imageId,
    imageUrl,
    imageAlt,
    linkUrl,
    linkTarget,
    maxWidth,
    padding
  } = attributes
  const blockProps = useBlockProps({
    className: 'coziehomes-logo'
  })

  const onSelectImage = media => {
    setAttributes({
      imageId: media.id,
      imageUrl: media.url,
      imageAlt: media.alt || ''
    })
  }

  const onRemoveImage = () => {
    setAttributes({
      imageId: 0,
      imageUrl: '',
      imageAlt: ''
    })
  }

  return (
    <>
      <InspectorControls>
        <PanelBody title={__('Logo Settings', 'coziehomes')}>
          <TextControl
            label={__('Link URL', 'coziehomes')}
            value={linkUrl}
            onChange={value => setAttributes({ linkUrl: value })}
            placeholder={__('https://example.com', 'coziehomes')}
            type='url'
          />
          <ToggleControl
            label={__('Open in new tab', 'coziehomes')}
            checked={linkTarget}
            onChange={value => setAttributes({ linkTarget: value })}
          />
          <RangeControl
            label={__('Max Width (px)', 'coziehomes')}
            value={maxWidth}
            onChange={value => setAttributes({ maxWidth: value })}
            min={50}
            max={600}
          />
          <RangeControl
            label={__('Padding (px)', 'coziehomes')}
            value={padding}
            onChange={value => setAttributes({ padding: value })}
            min={0}
            max={100}
          />
        </PanelBody>
      </InspectorControls>
      <div {...blockProps} style={{ padding: padding ? `${padding}px` : undefined }}>
        <MediaUploadCheck>
          <MediaUpload
            onSelect={onSelectImage}
            allowedTypes={['image']}
            value={imageId}
            render={({ open }) => (
              <>
                {imageUrl ? (
                  <>
                    <img
                      src={imageUrl}
                      alt={imageAlt}
                      className='coziehomes-logo__img'
                      style={{ maxWidth: `${maxWidth}px` }}
                      onClick={open}
                      role='presentation'
                    />
                    <Button
                      onClick={onRemoveImage}
                      isDestructive
                      size='small'
                      variant='secondary'
                      className='coziehomes-logo__remove-btn'
                    >
                      {__('Remove', 'coziehomes')}
                    </Button>
                  </>
                ) : (
                  <div
                    className='coziehomes-logo__placeholder'
                    onClick={open}
                    role='button'
                    tabIndex={0}
                    onKeyDown={e => e.key === 'Enter' && open()}
                  >
                    <Button
                      size='small'
                      variant='primary'
                      className='coziehomes-logo__upload-btn'
                    >
                      {__('Select Logo', 'coziehomes')}
                    </Button>
                  </div>
                )}
              </>
            )}
          />
        </MediaUploadCheck>
      </div>
    </>
  )
}
